(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbStatusDataStore', [
			'$q', 
			'smbStatusService', 
			StatusDataStore
			]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbStatusDataStore
	 * 
	 * @description
	 * Data store that manages state for the content type uration section.
	 */
	function StatusDataStore($q, smbStatusService) {

		var _contentStatus;
		var _todoStatus;
		var _assignedUserId;
		var _assignedDate;

		var _contentStatusValues = [];
		var _todoStatusValues = [];

		return {
			/**
			 * @ngdoc method
			 * @name smbStatusDataStore.getContentStatuses
			 * @methodOf smb-app.smbStatusDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads the data store with a content type by id
			 * 
			 * @param {String} groupId Id of the content type group the type belongs to
			 * @param {String} id The content type id
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the content type being loaded
			 */
			get contentStatus() { return _contentStatus; },

			get todoStatus() { return _todoStatus; },

			get contentStatusValues() { return _contentStatusValues; },

			get todoStatusValues() { return _todoStatusValues; },

			get assignedUserId() { return _assignedUserId; },

			get assignedDate() { return _assignedDate; },

			loadStatuses: loadStatuses,

			getDocumentStatus: getDocumentStatus,

			getUsersWithModifyRights: getUsersWithModifyRights,

			setDocumentStatus: setDocumentStatus
		};

		function loadStatuses(folderId) {
			return smbStatusService.getStatuses(folderId)
			.then(function(response) {
				return response.filter(function statuses(tt) {
						return tt.TagTypeName.match(/&&_AirBase_.*/);
					});
			})
			.then(function mapStatuses(statuses) {
				_contentStatus = statuses.filter(function filterCStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_Content_Status/);
				});
				_todoStatus = statuses.filter(function filterTStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_ToDo_Status/);
				});
				_assignedUserId = statuses.filter(function filterCStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
				});
				_assignedDate = statuses.filter(function filterTStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_Assigned_Date/);
				});
				return statuses;
			});
		}

		function getDocumentStatus(documentId) {
			return smbStatusService.getDocumentStatus(documentId)
			.then(function(response) {
				return response;
			});
		}

		function getUsersWithModifyRights(documentId) {
			return smbStatusService.getUsers(documentId)
			.then(function(response) {
				return response.data;
			});
		}

		function setDocumentStatus(status, documentId) {
			return smbStatusService.setDocumentStatus(status, documentId);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/statusDataStore.js
// module id = 128
// module chunks = 1